export const ZOOM_APP_UPDATE_FEATURE_FLAG = "zoom-app-update";
